const messages = {
    scanWithBankApp: "뱅킹 앱으로 스캔하세요",
    scanWithCreditCardApp: "신용카드 앱으로 스캔하세요",
    scanOrOpenApp: "스캔하거나 앱을 열어 결제를 완료하세요",
    scanForPayment: "스캔하여 결제",
    scanWithBankApp: '뱅킹 앱으로 스캔하여 결제',
    changePaymentWarning: "결제 방법을 변경하면 이전 QR Code가 더 이상 유효하지 않습니다. 새로운 방법만 사용해 주세요.",
    swapShop: "새 매장으로 전환하시겠습니까?<br>",
    swapShopDespt: "이전 매장에서 선택한 항목은 저장되어 나중에 주문할 수 있습니다",
    sorryForInconvenient: '불편을 드려 죄송합니다',
    openAt: '영업 시작 시간',
    shopIsClosedToday: '오늘은 휴무입니다',
    checkOrderedItem: '주문한 음식 항목 확인',
    tryAgainIn: '재시도 가능 시간',
    lockUserPIN: "PIN을 5회 이상 잘못 입력하셨습니다",
    lockUserPINDespt: "5분 후 다시 시도해 주세요",
    inValidPIN: '잘못된 PIN',
    enterPasswordToAccessMenu: "메뉴에 접근하려면 PIN을 입력하세요",
    customersCanGetPasswordFromStaff: "PIN은 직원에게 문의하세요",
    tableNotAvailable: "테이블을 사용할 수 없습니다",
    contactStaffToOpenTable: "직원에게 연락하여 테이블을 열어주세요",
    outOfRestaurantRange: "레스토랑 범위 밖입니다",
    phoneIsMoreThan100MetersAwayFromRestaurant: "귀하의 휴대폰이 레스토랑에서 100미터 이상 떨어져 있습니다",
    restaurantIsCurrentlyClosed: "레스토랑이 현재 영업 종료되었습니다",
    restaurantOpenHours: "주방 영업 시간",
    packingSize: '패키지 크기',
    shippingDelivery: '배송',
    waitForPaymentDelivery: '결제 대기',
    readyForPcikup: '픽업 준비 완료',
    noNotifyNow: "현재 알림이 없습니다",
    noNotifyNowDespt: "서비스를 이용하시면 알림이 여기에 표시됩니다",
    newAddressDespt: "원활한 배달을 위해 정확한 목적지를 핀으로 찍고 위치 접근을 허용해 주세요",
    deleteAddressSuccess: '주소 삭제 완료',
    createProfileSuccess: "프로필 생성 완료",
    ex: '예시',
    receiverName: '수취인 이름',
    editAddress: '주소 수정',
    nameInputInvalid: '잘못된 이름',
    openInGoogleMap: 'Google Map에서 열기',
    pleaseSelectPaymentMethod: '결제 방법을 선택해 주세요',
    noDeliveryAddress: '배송 주소가 없습니다',
    noDeliveryAddressDespt: '배송 주소 정보를 추가해 주세요',
    deliveryType: '배달',
    pickupType: '픽업',
    shopIsClose: '매장 휴무',
    openingHoursDespt: '영업 시간',
    contactShop: '매장 문의',
    pickupAtShop: '픽업',
    thanksForOrderingDespt: '이용해 주셔서 감사합니다.<br>다음에 또 뵙겠습니다!',
    deliveredSuccess: '배달 완료',
    expireIn: '만료까지',
    waitForPayment: '결제 대기',
    waitForPaymentDespt: "시스템의 결제 확인을 기다려 주세요.<br>아직 결제하지 않으셨다면, 주문 취소를 방지하기 위해 지정된 시간 내에 결제를 완료해 주세요.",
    newOrderIn: '신규',
    inputRequestDetails: '요청 세부사항 입력',
    notification: '알림',
    noticeIfOrderReady: '주문이 픽업 준비되면 알려드립니다',
    orderIsReady: '주문이 픽업 준비되었습니다',
    thanksForOrdering: '이용해 주셔서 감사합니다',
    toPay: '결제',
    letOrder: '메뉴 페이지로 이동하여 지금 주문을 시작하세요',
    noTransaction: '거래 없음',
    menulists: '메뉴 목록',
    editPersonalDetails: '정보 수정',
    trackOrder: '주문 추적',
    myAccount: '내 계정',
    cart: '장바구니',
    helpCenter: '고객센터',
    allPurchaseHistory: '구매 내역',
    purchaseHistory: '구매 내역',
    personalInfo: '개인정보',
    cutlery: '수저',
    km: 'km',
    totalAmountSum: '합계',
    selectedItemList: '선택한 항목',
    iAm: '저는',
    orderedBy: '주문자',
    shareQRtoFriend: 'QR Code 공유',
    share: '공유',
    hasItemInBasket: '장바구니에 항목이 있습니다',
    hasItemInBasketDespt: '주방으로 보내는 것을 잊지 마세요',
    updatedAtQR: '업데이트 시간',
    orderSent: '주방으로 주문이 전송되었습니다',
    orderSentDespt: '레스토랑에서 음식을 준비 중입니다',
    checkGramdTotalIn: '에서 총 금액을 확인할 수 있습니다',
    vatNotInclude: '이 가격에는 세금, 서비스 요금, 할인이 포함되어 있지 않습니다',
    accept: '동의',
    termOfService: '서비스 이용약관',
    onPending: '대기 중',
    OnSuccessOrder: '완료',
    prepareingOrder: '주문 준비 중',
    deliveringOrder: '배달 중',
    pickupOrderReady: '픽업 준비 완료',
    pickedupOrder: '픽업 완료',
    deliveredOrder: '배달 완료',
    shopReceivedOrder: '매장에서 주문을 접수했습니다',
    orderId: '주문 ID',
    orderDetails: '주문 상세',
    deliveryFee: '배달비',
    searchDriver: '기사 검색 중',
    driverFrom: '기사',
    change: '변경',
    deliveryAddress: '배달 주소',
    location: '위치',
    addressName: '주소 이름',
    addressNameDespt: '예: 아파트명, 마을명',
    addressDescription: '주소 상세',
    addressDescriptionDespt: '예: 동/호수, 골목',
    noteToDriver: '기사에게 메모',
    noteToDriverDespt: '예: 입구 테이블에 놓아주세요',
    inputAddressForm: '배달 주소 입력',
    plsPinAddress: '위치를 핀으로 찍어주세요',
    pinLocation: '배달 위치 핀',
    createNewAddress: '새 주소 추가',
    savedAddress: '저장된 주소',
    phoneNumber: '전화번호',
    noRequired: '선택사항',
    resendCode: '코드 재전송',
    didNotGetCode: '코드를 받지 못하셨나요?',
    resendIn: '재전송까지',
    next: '다음',
    createAccount: '계정 만들기',
    createAccountDespt: '계속하려면 아래 양식을 작성하여 계정을 만드세요',
    sendCodeViaSMS: 'SMS로 코드 전송',
    inputOTP: 'OTP 입력',
    inputOTPDespt: '전송된 6자리 코드를 입력하세요',
    termAndPolicy: '이용약관 및 정책',
    termAndPolicy1: '서비스를 이용함으로써 다음에 동의하는 것으로 간주됩니다',
    termAndPolicy2: '이용약관 및 정책 전문을 읽으려면 클릭하세요',

    loginWithPhoneNumber: '전화번호로 로그인',
    loginWithPhoneNumberDespt: '본인 확인을 위한 OTP를 받을 전화번호를 입력하세요',
    backToOrder: '메뉴로 돌아가기',
    PaymentMethod: '결제',
    paymentAmount: '결제 금액',
    paymentConfirmation: '결제 확인',
    cancelPayment: '결제 취소',
    paidSuccess: '결제 완료',
    haveNotPurchased: '아직 구매하지 않았습니다',
    haveNotPurchased2: '결제 실패 시 직원에게 문의하세요',
    canNotOrderItem: '결제 중에는 음식을 주문할 수 없습니다',
    checkPaymentStatus: '상태 확인',
    pendingPayment: '결제 대기 중',
    askForReceipt: '영수증이 필요하시면 직원에게 문의하세요',
    paymentSuccess: '결제 성공',
    summaryPayment: '요약',
    numberOfGuest: '인원 수',
    closeTab: '닫기',
    addCredit: '신용카드 추가',
    QRPayment: 'QR 결제',
    cardPayment: '신용카드',
    payWithStaff: '카운터에서 결제',
    selectPaymentMethod: '결제 방법 선택',
    checkOut: '계산',
    startOrderBeforeCallStaff: '직원을 호출하기 전에 먼저 주문해 주세요',
    basket: '장바구니',
    spoon: '수저 요청',
    knife: '나이프 요청',
    chopstick: '젓가락 요청',
    cup: '컵 요청',
    plate: '접시 요청',
    glass: '잔 요청',
    payBill: '계산 요청',
    viewAll: '모두 보기',
    recommendMenu: '추천',
    OnSuccess: '완료',
    OnPreparing: '준비 중',
    messageSent: '직원을 기다려 주세요',
    outOfStock: '품절',
    QRCode: 'QR Code',
    GenerateQRCode: 'QR Code 생성',
    ForQROrder: '음식 주문 및 매장 내 서비스 요청용',
    QROrderDescription: '고객이 음식 주문과 매장 내 서비스 요청을 위해 스캔할 수 있는 QR Code를 생성할 수 있습니다',
    SelectTable: '테이블을 선택하고 인원 수를 입력하세요.',
    shopname: '매장명',
    numberOfCustomer: '고객 수 (명)',
    numberOfCustomerDescription: '고객 수를 입력하세요, 최소 1명',
    currentUser: '사용자',
    guest: '손님',
    orderItem: '주문 요약',
    orderItemNav: '주문 요약',
    callStaff: '직원 호출',
    callStaffDialog: '어떤 도움이 필요하신가요?',
    cutlery: '수저 요청',
    seasoning: '조미료 요청',
    refillDrink: '음료 리필 요청',
    other: '기타',
    tableNumber: '테이블',
    menuList: '메뉴',
    selectedItem: '음식 주문',
    selectedItemNav: '음식 주문',
    checkOrderBeforeConfirm: '레스토랑에 보내기 전에 주문 내용과 합계를 확인해 주세요',
    checkOrderBeforeConfirm2: '',
    startOrder: '주문 시작',
    foodCategory: '카테고리',
    searchByName: '상품명으로 검색...',
    noPreduct: '상품이 없습니다',
    noSelectedProduct: '선택된 상품이 없습니다',
    noSelectedProductDespt: '상품을 선택하면 선택 목록이 이 페이지에 표시됩니다',
    backToMenu: '메뉴로 이동',
    removeSelected: '이 항목을 삭제하시겠습니까?',
    confirmOrder: '주문 제출',
    endOfTransection: '거래 종료',
    endOfTransectionDialog: '이용에 문제가 있으시면 직원에게 문의하세요',
    note: '메모',
    orderTime: '주문 시간',
    orderMoreFood: '메인 메뉴로 돌아가기',
    orderPreparing: '셰프가 음식을 준비 중입니다. 잠시만 기다려 주세요. 곧 제공됩니다',
    orderPreparing2: '',
    sendingOrder: '주방으로 주문 전송 중...',
    login: '로그인',
    forgetPassword: '비밀번호를 잊으셨나요?',
    loginWithGmail: 'Gmail로 로그인',
    or: '또는',
    loginAsStaff: '직원으로 로그인',
    billOrder: '전표',
    table: '테이블',
    billOrderDialog: 'QR Code를 스캔하여 메뉴를 보고 주문하세요',
    billOrderDialog2: '이용에 문제가 있으시면 직원에게 문의하세요',
    selectTableAleart: 'QR Code를 생성하기 전에 테이블을 선택하세요',
    emptyCartDialog: '거래 없음',
    emptyCartDialogDespt: '주문을 확인하면 주문한 항목 목록이 이 페이지에 표시됩니다',
    served: '서빙 완료',
    contactOurStaff: '직원 연락',
    contactOurStaff2: '도움이 필요한 경우',
    addToCart: '장바구니에 추가',
    noteToShop: '매장에 메모',
    addYourRequest: '요청사항 추가',
    branchName: '지점명',
    businessType: '업종',
    taxID: '사업자등록번호',
    vat: '세금',
    exclusive: '세전',
    inclusive: '세후',
    serviceCharge: '서비스 요금',
    address: '주소',
    address1: '주소 1',
    address2: '주소 2',
    tel: '전화',
    businessType1: '일반',
    businessType2: '레스토랑',
    businessType3: '호스텔',
    shopopen: '영업 - 마감',
    open: '영업 중',
    closed: '마감',
    languagetxt: '언어',
    language: '언어 및 시간대',
    languageTH: '태국어',
    languageEN: '영어',
    setting: '설정',
    shop: '매장',
    timezone: '시간대',
    deliveryProviders: '배달 업체',
    adddeliveryProviders: '업체 추가',
    lastUpdate: '최종 업데이트',
    logo: '로고',
    updateData: '데이터 업데이트',
    submit: '제출',
    cancel: '취소',
    normal: '일반',
    loading: '로딩 중...',
    editing: '편집 중',
    confirmUpdate: '데이터를 업데이트하시겠습니까?',
    selectedShoptype: '업종 선택...',
    selectshop: '지점명 선택',
    save: '저장',
    reporttxt: '보고서',
    general: '일반',
    signOut: '로그아웃',
    registration: '',
    unit: '단위',
    category: '카테고리',
    product: '상품',
    export: '내보내기',
    exportKBank: 'K-Bank 내보내기',
    date: '날짜',
    to: '까지',
    status: '상태',
    vatAmount: '세금',
    netTotalNonVAT: '합계 (세전)',
    receiptNumber: '영수증 번호',
    grandTotal: '총합계',
    netAmountVATTotal: '소계',
    netTotalIncVAT: '합계 (세후)',
    proofOfPayment: '결제 증빙',
    paymentType: '결제 유형',
    paymentType0: '현금',
    paymentType1: '신용카드',
    paymentType2: '쿠폰',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: '보증금',
    paymentType7: '배달',
    paymentType8: '온라인',
    paymentType9: 'Line Pay',
    paymentType10: '커스텀 결제',
    paymentType12: 'KBank',
    paid: '결제 금액',
    sentSuccessfully: '전송 완료',
    pluCode: '바코드',
    netAmount: '순합계',
    discount: '할인',
    timeOfOrder: '주문 시각',
    orderDate: '주문 날짜',
    preparing: '준비 중',
    paymentDetail: '결제 상세',
    orderNumber: '주문 번호',
    delivered: '마감일',
    deliveredDate: '리드타임',
    payment: '결제',
    productName: '상품명',
    quantity: '수량',
    priceUnit: '단가',
    baht: '바트',
    profit: '이익',
    sales: '매출',
    billAmount: '청구 합계',
    total: '합계',
    bill: '전표',
    discountAmount: '할인 금액',
    averageBill: '평균/전표',
    voidbillTotal: '무효 전표 합계',
    salesByDaily: '일별 매출',
    salesByMonth: '월별 매출',
    bestSellers: '베스트셀러',
    bestSellerstype: '베스트셀러 카테고리',
    salesBydate: '날짜별 매출',
    number: '번호',
    categoryName: '카테고리명',
    newOrder: '주문 전송',
    reject: '거부',
    inProgressTime: '처리 시간',
    rejectTime: '거부 시간',
    cancelTime: '취소 시간',
    cause: '원인',
    preparingToShip: '준비 중',
    totalAmount: '합계',
    order: '주문',
    deposit: '보증금',
    billSave: '저장',
    ReceivingOrder: '테이블 열기/주문 접수',
    orderNo: '주문번호',
    remark: '비고',
    receiptStatus: '영수증 상태',
    back: '뒤로',
    detail: '상세',
    countSales: '수량',
    onhandQty: '재고',
    stdCost: '원가',
    employees: '직원',
    employeesname: '직원명',
    salesTotal: '매출 합계',
    totalBill: '전체 전표 수',
    billActive: '판매 전표 수',
    billVoice: '취소 전표 수',
    billDeposit: '보증금 전표 수',
    discountItem: '상품 할인 합계',
    billDiscountAmount: '전표 할인 합계',
    billDiscount: '할인 전표 수',
    payTotal: '결제 합계',
    deliveryProvider: '배달 업체',
    deliveryDetail: '배달 상세',
    customDetail: '커스텀 결제 상세',
    customPaymentName: '커스텀 결제명',
    firstInvoiceNO: '첫 번째 전표 번호',
    lastInvoiceNO: '마지막 전표 번호',
    roundNo: '라운드 번호',
    closeAt: '마감 시간',
    closeBy: '마감 담당',
    totalCashSales: '현금 매출 합계',
    initialChange: '초기 잔돈',
    totalCashIn: '총 입금',
    totalCashOut: '총 출금',
    actualInDrawer: '서랍 실제 금액',
    expectedInDrawer: '서랍 예상 금액',
    difference: '차이',
    voidBillDetail: '무효 전표 상세',
    cancelBy: '취소 담당',
    cancelDate: '취소 날짜',
    searchByEmployees: '직원으로 검색',
    search: '검색',
    timeIn: '출근',
    timeOut: '퇴근',
    time: '시간',
    hours: '시간',
    seconds: '초',
    netTotal: '합계',
    reason: '사유',
    searchByProduct: '상품으로 검색',
    sortBy: '정렬 기준',
    last: '최신',
    price: '상품 가격',
    sortByNumMin: '최저가',
    sortByNumMax: '최고가',
    documentNo: '문서 번호',
    transactionType: '거래 유형',
    updatedBy: '업데이트 담당',
    transactionType1: '판매',
    transactionType2: '환불',
    transactionType3: '입고',
    transactionType4: '출고',
    transactionType5: '재고 조정 (증가)',
    transactionType6: '재고 조정 (감소)',
    transactionType7: '포인트 교환',
    transactionType8: '입고 삭제',
    transactionType9: '출고 삭제',
    transactionType10: '입고 수정',
    transactionType11: '출고 수정',
    billNo: '전표 번호',
    docTotal: '합계',
    customer: '고객',
    username: '사용자명',
    dateOfBill: '전표 날짜',
    selectDate: '날짜 선택',
    dialogSelectCategory: '검색할 카테고리를 선택해 주세요',
    dialogUpdateDocumentSuccess: '문서 업데이트 완료',
    dialogfound: '입력된 정보가 올바르지 않습니다.',
    isVatIncluded: 'VAT 포함 여부',
    vatIccludes: 'VAT',
    confirmStock: '재고 확인',
    confirm: '확인',
    deleteDoc: '문서 삭제',
    confirmUpdateDocModal: '재고 문서를 업데이트하시겠습니까?',
    confirmSaveDoc: '문서 저장 확인',
    confirmDeleteDoc: '문서 삭제 확인',
    confirmDeleteModal: '재고 문서를 삭제하시겠습니까?',
    dialogSaveDocumentSuccess: '문서 저장 완료',
    createStockIn: '입고 생성',
    confirmSaveDocModal: '재고 문서를 저장하시겠습니까?',
    selectShopPlease: '매장을 선택해 주세요',
    selectProductPlease: '상품을 선택해 주세요',
    duplicateProduct: '이미 선택된 상품입니다.',
    productInvilid: '선택한 상품이 유효하지 않습니다. 시스템 관리자에게 문의하세요.',
    confirmStockOut: '출고 확인',
    dialogSaveDocumentOutSuccess: '문서 저장 완료',
    confirmSaveDocStockOutModal: '출고 문서를 저장하시겠습니까?',
    adjustDocType: '조정 문서 유형',
    adjustDocType1: '증가',
    adjustDocType2: '감소',
    beforeAdjust: '재고 조정 전',
    afterAdjust: '재고 조정 후',
    adjust: '재고 조정',
    createDoucument: '문서 생성',
    transferType: '이동 유형',
    transferType1: '입고 이동',
    transferType2: '출고 이동',
    new: '신규',
    finish: '완료',
    refDocument: '참조 문서',
    statusDoc: '문서 상태',
    dialogSaveTransferDocumentSuccess: '이동 문서 생성 완료',
    destinationShop: '목적지 매장',
    destinationShopBranch: '목적지 지점',
    sourceBranch: '출발지 지점',
    sourceShop: '출발지 매장',
    sourceAddress: '출발지 주소',
    destinationAddress: '목적지 주소',
    saveTransfer: '재고 이동 저장',
    confirmSaveTransfer: '재고 이동을 저장하시겠습니까?',
    savinserviceChargegDoc: '문서 저장 중',
    selectdestinationPlease: '목적지 지점을 선택해 주세요',
    validatedestinationproduct: "목적지 지점에 해당 상품이 없습니다",
    validateProduct: '상품을 선택해 주세요',
    created_by: '작성자',
    receive: '수령',
    updateDoc: '문서 업데이트',
    cancelDoc: '문서 취소',
    confirmCancelDoc: '이 문서를 취소하시겠습니까?',
    cancelingDoc: '문서 취소 중',
    updatingDoc: '문서 업데이트 중',
    updateDocFail: "문서를 업데이트할 수 없습니다",
    cancelDocSuccess: '문서 취소 완료',
    cancelDocFail: "문서를 취소할 수 없습니다",
    refDocumentTransfer: '참조 문서',
    comfrimTransferIn: '입고 이동 확인',
    dilogcomfrimTransferIn: '입고 이동 문서를 처리하시겠습니까?',
    transferInDetail: '재고 이동 상세',
    totalNet: '순합계',
    confirmAdjust: '재고 조정 확인',
    createStockOut: '출고 생성',
    favorite: '즐겨찾기',
    isOnScreen: '화면에 표시',
    negotiatePrice: '가격 협상',
    productTypeP: '일반 상품',
    productTypeBOM: '자재명세서',
    productTypeSN: '시리얼 상품',
    productTypeSV: '서비스 (비재고)',
    productPLU: '기타 패키지 크기',
    productBOM: '자재',
    productSN: 'Serial Number',
    morePrice: '기타 가격',
    cost: '원가',
    quantityPrice: '수량',
    exceedUc: '가격',
    changeImg: '이미지 변경',
    addProduct: '상품 추가',
    selectImg: '이미지 선택',
    deleteImg: '이미지 삭제',
    selectImgFromPC: 'PC에서 이미지 선택',
    confirmSaveImgDialog: '상품을 저장하시겠습니까?',
    confirmSaveImg: '상품 저장 확인',
    addPrice: '가격 추가',
    editPrice: '가격 수정',
    dialigDeleteProduct: '상품을 삭제하시겠습니까?',
    confirmDeleteProduct: '이 상품 삭제 확인',
    productType: '상품 유형',
    countProduct: '상품 수',
    addUnit: '단위 추가',
    editUnit: '단위 수정',
    active: '활성',
    inactive: '비활성',
    confirmSaveUnitDialog: '단위를 저장하시겠습니까?',
    confirmSaveUnit: '이 단위 저장 확인',
    dialigDeleteUnit: '단위를 삭제하시겠습니까?',
    confirmDeletUnit: '이 단위 삭제 확인',
    confirmSaveCategoryDialog: '카테고리를 저장하시겠습니까?',
    confirmSaveCategory: '이 카테고리 저장 확인',
    dialigDeleteCategory: '카테고리를 삭제하시겠습니까?',
    confirmDeletCategory: '카테고리 삭제 확인',
    addCategory: '카테고리 추가',
    editCategory: '카테고리 수정',
    bgColor: '배경색',
    selectbgColor: '배경색 선택',
    validateCategoryname: '카테고리 이름을 입력해 주세요.',
    sequence: '순서',
    enterProduct: '상품명을 입력해 주세요.',
    enterPrice: '상품 가격을 입력해 주세요.',
    selectCategory: '상품 카테고리를 선택해 주세요.',
    selectUnit: '상품 단위를 선택해 주세요.',
    confirmSaveProduct: '이 상품을 저장하시겠습니까?',
    confirmSaveProductPrice: '기타 가격을 저장하시겠습니까?',
    validatepackQty: '단가를 입력해 주세요.',
    validatepackUc: '가격을 입력해 주세요.',
    validatePRU: '중복 데이터입니다. 다시 입력해 주세요.',
    createProductSuccess: '상품 생성 완료',
    addSerial: '시리얼 추가',
    add: '추가',
    createSerial: 'Serial Number 생성',
    available: '판매 가능',
    soldOut: '품절',
    deleteSuccess: '삭제 완료',
    enterSerial: 'Serial Number를 입력해 주세요',
    confirmSaveSerial: '이 Serial Number를 저장하시겠습니까?',
    confirmDelete: '이 Serial Number를 삭제하시겠습니까?',
    addProductPLU: '패키지 크기 추가',
    img: '이미지',
    SKURatio: '비율',
    editProductPLU: '패키지 크기 수정',
    enterSKURatio: '비율을 입력해 주세요',
    comfrimDeletePLU: '이 패키지 크기를 삭제하시겠습니까?',
    useStepPrice: '단계 가격 사용',
    addBOM: '자재 추가',
    confirmSaveBOM: '자재를 저장하시겠습니까?',
    user: '사용자',
    userDetail: '사용자 상세',
    planDetail: '플랜 상세',
    currentPlan: '현재 플랜',
    expireDate: '만료일',
    startDate: '시작일',
    dialogSignOut: '로그아웃하시겠습니까?',
    confirmSignOut: '로그아웃 확인',
    countMember: '전체 회원',
    addMenber: '회원 추가',
    searchMember: '이름, 이메일, 전화번호로 검색',
    dateOfMember: '회원 등록일',
    recentVisit: '최근 방문',
    memberName: '회원명',
    email: '이메일',
    paymentTotal: '결제 합계',
    point: '포인트',
    pointtxt: '포인트',
    postalCode: '우편번호',
    saveing: '저장 중...',
    edit: '수정',
    editMember: '회원 수정',
    deleteing: '삭제 중...',
    dialogDeleteMember: '회원을 삭제하시겠습니까?',
    confirmDeleteMember: '삭제 확인',
    valtdateMember: '정보를 입력해 주세요',
    createMemberSuccess: '회원 추가 완료!',
    updateMemberSuccess: '회원 수정 완료!',
    deleteMemberSuccess: '회원 삭제 완료!',
    onhandQtyMin: '최소 재고',
    onhandQtyMax: '최대 재고',
    onhandQtySort: '재고 수량',
    showProductAll: '전체 상품 유형',
    updateAt: '최종 업데이트',
    sortName: '이름',
    stockUnit: '단가 원가',
    deleteCategory: '카테고리 삭제',
    selectd: '선택',
    searchProduct: '상품 검색',
    reset: '초기화',
    selectdProduct: '상품 선택',
    information: '정보',
    adjustStockList: '재고 조정 상품',
    adjustDetail: '재고 조정 목록에 상품 추가 및 설정',
    transferoutList: '재고 이동 상품',
    addProductTransfer: '재고 이동 목록에 상품 추가 및 설정',
    transferDetail: '출고 목록에 상품 추가 및 설정',
    transferinList: '입고 목록에 상품 추가 및 설정',
    stockOutList: '출고 상품',
    addstockOutList: '출고 목록에 상품 추가 및 설정',
    stockinList: '입고 상품',
    addProductStockin: '입고 목록에 상품 추가 및 설정',
    checkCount: '재고 확인',
    createAdjustStock: '재고 조정 생성',
    memberDetail: '회원 정보',
    package: '패키지 상세',
    startPackate: '패키지 시작',
    endPackate: '패키지 종료',
    name: '이름',
    productImg: '상품 이미지',
    fistname: '이름',
    lastname: '성',
    saveMember: '정보 저장',
    confirmSaveMember: '회원을 저장하시겠습니까?',
    yesOrNo: '예/아니오',
    totaValue: '합계',
    deleteMember: '회원 삭제',
    frequently: '자주 주문한 상품',
    recentPurchase: '최근 구매',
    paymentDescription: '결제 설명',
    validateInfomation: '정보를 입력해 주세요',
    validateTel: '전화번호가 올바르지 않습니다',
    validateOTP: 'OTP가 올바르지 않습니다',
    validateEmail: '이메일이 올바르지 않습니다',
    saveSuccess: '저장 완료',
    txtcustomer: '고객',
    customerName: '고객명',
    customerCount: '고객 수',
    addCustomer: '고객 추가',
    permissionManage: '권한',
    mainMenu: '메인 메뉴',
    page: '페이지',
    show: '표시',
    delete: '삭제',
    administratorTools: '관리자 도구',
    deviceName: '기기명',
    lastSyncProduct: '최종 동기화',
    version: '버전',
    posstatus: '상태',
    posNumber: 'POS 번호',
    titleSilomconnect: '다음 서비스로 매출을 놓치지 마세요',
    updateSilom: 'LINE으로 일일 매출 무료 업데이트',
    addfriend: '친구 추가',
    enterToReciveService: '서비스 이용 코드를 받으려면 눌러주세요.',
    verifyCodeToUsed: '시스템 사용을 시작하려면 본인 확인 코드를 받으려면 눌러주세요.',
    verifyfivemin: '인증 코드는 5분간 유효합니다.',
    yourVertify: '인증 코드',
    pressCode: '코드 받기',
    exCode: '코드 만료',
    sessionEx: '로그인 세션이 만료되었습니다. 다시 로그인해 주세요.',
    refresh: '새로고침',
    selectedFile: '파일 선택',
    fileSize: '파일 크기는 2MB 이하여야 합니다.',
    isBeingToUsed: '사용 중',
    notInUse: '미사용',
    delete: '삭제',
    confirmUpdateInformation: '정보 업데이트 확인',
    memberCount: '인원',
    orderMachine: '주문 기기',
    textMember: '회원',
    manageShop: '매장 정보 관리',
    lansetting: '매장 언어 및 시간대 설정',
    timezoneSetiing: '매장 시간대 설정',
    deliveryProviderSetting: '매장 배달 업체',
    toolsSetting: '매장 POS 기기 관리',
    checkStockPLU: '상품 잔고 < 0',
    searching: '검색 중',
    allProduct: '전체 상품',
    foundProductOnhand: '재고 < 0인 상품이 발견되었습니다',
    confirmAdjustBefor: '시스템으로 자동 조정하시겠습니까?',
    requireAdjust: '예',
    imrequireAdjust: '아니오',
    islimitItemTodoc: '문서당 최대 200개 상품까지 선택할 수 있습니다.',
    barcodePrint: '바코드 인쇄',
    printEx: '인쇄 및 예시',
    print: '인쇄',
    downloadAndExport: '다운로드 및 인쇄',
    selectFormat: '용지 형식 선택',
    peperFormat: '용지 형식',
    optional: '선택사항',
    standardA427: 'A4 표준: 27개/페이지',
    standardA450: 'A4 표준: 52개/페이지',
    standardA460: 'A4 표준: 60개/페이지',
    standardA556: 'A4 표준: 56개/페이지 (스티커 크기: A5)',
    standardA550: 'A5 용지: 52개/페이지',
    standardA560: 'A5 용지: 60개/페이지',
    countBarcode: '바코드 수',
    barcode: '바코드',
    setFontsize: '글꼴 설정',
    accessPermissionDes: '사용자에게 접근 권한을 할당합니다.',
    deleteUser: '사용자 삭제 확인',
    confirmDeleteUser: '사용자를 삭제하시겠습니까?',
    passAtless: '비밀번호는 최소 6자 이상이어야 합니다.',
    inValidPass: '잘못된 비밀번호',
    createBy: '작성자',
    adjustAutoDes: "시스템 자동 업데이트를 하지 않으면 상품의 총 재고가 올바르지 않을 수 있습니다.",
    addUser: '사용자 추가',
    isMenu: '고객 메뉴에 표시',
    menuSmart: '상품 메뉴 설정',
    smartSettingTitle: '메뉴 설정',
    smartSetting: 'Silom CRM 메뉴 설정',
    confirmEnable: '메뉴를 활성화하시겠습니까?',
    confirmDisEnable: '메뉴를 비활성화하시겠습니까?',
    confirmSelfOrderEnable: '셀프 주문 메뉴를 활성화하시겠습니까?',
    confirmSelfOrderDisable: '셀프 주문 메뉴를 비활성화하시겠습니까?',
    enable: '활성',
    disable: '비활성',
    usabilityStatus: '활성',
    manageSmartOnProduct: '상품 페이지에서 고객에게 표시할 상품 목록을 추가/수정할 수 있습니다.',
    manageSmartOnCategory: '카테고리 페이지에서 고객에게 표시할 카테고리 목록을 추가/수정할 수 있습니다.',
    turnonSmart: '메뉴 활성화',
    manageShopDes: '사용자 매뉴얼은 다음을 참조하세요 -',
    desSmartMenu: 'LINE에서 E-menu를 표시하기 위한 상품 메뉴를 설정하여 고객이 쉽게 접근하고 직접 주문할 수 있도록 합니다.',
    link: '링크',
    createTranferOut: '출고 이동 문서 생성',
    roundingValue: '단수 조정',
    limitItems: '상품은 최대 200개까지 선택 가능',
    IncomeCategory: '수입',
    ExpenseCategory: '지출',
    saveBy: '저장 담당',
    saveDate: '저장 날짜',
    drawerCate: '카테고리',
    openingHours: '영업 시간',
    shopLocation: '매장 위치',
    sunday: '일요일',
    monday: '월요일',
    tuesday: '화요일',
    wednesday: '수요일',
    thursday: '목요일',
    friday: '금요일',
    saturday: '토요일',
    lat: '위도',
    lng: '경도',
    shopCoverSetting: '매장 커버 설정',
    shopCoverSettingDes: '고객 화면에 표시할 매장 커버 설정',
    locationSettingDes: '위치 설정',
    updatelocation: '위치 업데이트',
    searchLocation: '위치 검색',
    imaginaryLine: '가상선',
    openingHoursDes: '매장 영업 시간 설정',
    paymentDescriptionConfig: '결제 방법 선택',
    creditCard: '신용카드',
    promptPay: 'Promptpay',
    coupon: '쿠폰',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: '월',
    dayMY: '날짜',
    item: '항목',
    byStockIn: '입고',
    stockOutOther: '기타',
    drawerSales: '매출',
    sumIncomeExpenses: '수입-지출 요약',
    incomeOther: '기타 수입',
    loss: '손실',
    grossProfit: '매출총이익',
    newUser: '신규 사용자',
    userType: '사용자 유형',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    ParticipatingProducts: '상품 선택',
    descriptionSilomOrder: 'order.silompos.com용 상품 선택',
    cashierManagement: '캐셔 관리',
    cashierManageButton: '관리',
    cashierUsernamePassword: '캐셔 사용자 이름 및 비밀번호',
    cashierCRUDDescription: 'order.silompos.com 로그인용',
    password: '비밀번호',
    placeholderPassword: '비밀번호 입력',
    resetPassword: '비밀번호 재설정',
    oldPassword: '기존 비밀번호',
    oldPasswordPlaceholder: '이전 비밀번호',
    newPassword: '새 비밀번호',
    purchaseDetail: '구매 상세',
    uploadImage: '이미지 업로드',
    keyword: '키워드',
    firstname: '이름',
    lastname: '성',
    province: '도/시',
    district: '구/군',
    subdistrict: '동/읍',
    addressNumber: '주소',
    setAsDefaultAddress: '기본 주소로 설정',
    setAsTaxAddress: '세금 주소로 설정',
    setAsShippingAddress: '배송 주소로 설정',
    contact: '연락처',
    setAsDefault: '기본값으로 설정',
    addressLists: '주소 목록',
    default: '기본',
    taxAddress: '세금 계산서',
    shippingAddress: '배송',
    addAddress: '추가',
    createdAt: '생성일',
    updatedAt: '수정일',
    by: '담당',
    readyForSale: '판매 가능',
    sold: '판매됨',
    delete: '삭제',
    items: '항목',
    itemDiscount: '상품 할인',
    failedToSave: '저장 실패!',
    dateOfBirth: '생년월일',
    menu: '메뉴',
    dashboardMenu: '대시보드',
    transactionMenu: '거래',
    currentBillMenu: '현재 전표',
    reportMenu: '보고서',
    orderDeviceMenu: '주문 기기',
    memberMenu: '회원',
    inventoryMenu: '재고',
    productMenu: '상품',
    selfOrderMenu: '판매 채널',
    settingMenu: '설정',
    salesReportByDate: '날짜별 매출',
    salesReportByBill: '전표별 매출',
    salesQuantitySummaryByProductReport: '상품별 매출',
    quantitySummaryByPLUReport: '상품별 매출 (PLU)',
    nonSellingProduct: '미판매 상품',
    salesSummaryByCashierReport: '캐셔별 매출',
    salesSummaryByCategoryReport: '카테고리별 매출',
    paymentReport: '결제',
    salesTaxReport: '세금',
    drawerReport: '서랍',
    voidBillReport: '무효 전표',
    timesheetReport: '근무표',
    stockInByListReport: '상품별 입고',
    stockOutByListReport: '상품별 출고',
    nonAdjustStockProductReport: '미조정 재고 상품',
    exportProductReport: '상품 내보내기',
    salesSummaryByOrderReport: '주문 기기별',
    salesSummaryProductByOrderReport: '상품별',
    voidBillByOrderReport: '무효 전표',
    inventoryReport: '재고 보고서',
    inventoryReportByPLU: 'PLU별 재고 보고서',
    inventoryReportBySerial: 'Serial No.별 재고 보고서',
    stockMovement: '재고 이동',
    stockInDocument: '입고 문서',
    stockOutDocument: '출고 문서',
    adjustStockDocument: '재고 조정 문서',
    selfOrder: '셀프 주문',
    cashier: '캐셔',
    permission: '권한',
    menuSetting: '메뉴 설정',
    management: {
        txtManagement: '관리',
        user: '계정',
        shopBranch: '매장 및 지점',
        productManagement: '상품',
        unitManagement: '단위',
        categorytManagement: '카테고리',
        inventory: '재고',
        stockIn: '입고',
        stockOut: '출고',
        adjustStock: '재고 조정',
        checkStock: '재고 확인',
        stockMovement: '재고 이동',
        transferStock: '재고 이동',
        reportByPLU: 'PLU별 재고 보고서',
        reportBySKU: '재고 보고서',
        txtreportBySKU: '재고 보고서',
        txtreportByPLU: 'PLU별 재고 보고서',
        stockInDoc: '입고 문서',
        stockOutDoc: '출고 문서',
        adjustStockDoc: '재고 조정 문서',
        transferStockDoc: '재고 이동 문서',
        transferStockInDoc: '입고 이동 문서',
        transferStockOutDoc: '출고 이동 문서',
    },
    report: {
        dashboard: '대시보드',
        transaction: '거래',
        currentbill: '현재 전표',
        daily: '날짜별',
        txtdaily: '날짜별 매출 보고서',
        dailyDes: '날짜별 매출 보고서 상세',
        sellbyProduct: '전표 상세별',
        txtsellbyProduct: '전표 상세별 매출 보고서',
        sku: '상품별',
        txtsku: '상품별 매출 보고서',
        plu: '상품별 (PLU)',
        textPlu: '상품별 매출 보고서 (PLU)',
        paymentreport: '결제 보고서',
        txtpaymentreport: '결제 보고서',
        timesheet: '근무표',
        txtTimesheet: '근무표 보고서',
        unsell: '미판매 상품',
        txtUnsell: '미판매 상품',
        byCategory: '카테고리별',
        txtbyCategory: '카테고리별 매출 보고서',
        byCashier: '캐셔별',
        txtbyCashier: '캐셔별 매출 보고서',
        salesTax: '세금 보고서',
        txtSalesTax: '세금 보고서',
        voidbill: '무효 전표',
        txtvoidbill: '무효 전표 보고서',
        closedSale: '마감',
        txtCloseSale: '서랍 보고서',
        salesByOrder: '매출 요약',
        productByOrder: '상품별',
        unsalesByOrder: '무효 전표',
        txtDeliveryRoport: '배달별 결제 보고서',
        txtCustomReport: '커스텀 결제 보고서',
        txtSalesByOrder: '주문 기기별 상품 매출',
        txtDailyOrder: '주문 기기별 매출 보고서',
        txtViodOrder: '주문 기기별 무효 전표',
        nonadjust: '미조정 재고 상품',
        txtnonadjust: '미조정 재고 상품 보고서',
        stockInReport: '상품별 입고 보고서',
        stockOutReport: '상품별 출고 보고서',
        stockIn: '상품별 입고',
        stockOut: '상품별 출고',
        exportProduct: '상품 내보내기',
        txtExportProduct: '상품 내보내기 보고서',
        cashDrawer: '서랍',
        txtCashDrawerr: '현금 관리 보고서',
        cashRevenue: '현금 수입',
    },
    drawer: {
        cashDrawer: '서랍',
        txtCashDrawerr: '현금 관리 보고서',
        cashRevenue: '수입-지출 요약',
        txtcashRevenue: '수입-지출 요약 보고서',
    },
    member: {
        txtmember: '회원',
        register: '매장 등록 (LINE OA)',
        loyaltyPoint: '로열티 포인트',
        storeCredit: '매장 크레딧',
        deal: '딜',
        giftVoucher: '상품권',
        referral: '초대',
        crm: 'Silom CRM',
    },
    unableStockDescription: '문서 생성 후 재고가 업데이트되어 상품을 수정할 수 없습니다.',
    noItem: '항목 없음',
    enterProductName: '상품명 입력',
    ByCategory: '카테고리별',
    ByCategoryDetail: '카테고리별 상세',
    maximum: '최대',
    selectZone: '구역 선택',
    minimum: '최소',
    unlimited: '무제한',
    startTime: '시작 시간',
    endTime: '종료 시간',

    "errorMessages": {
        "qrExpired": "QR Code 만료",
        "qrNotFound": "QR Code를 찾을 수 없음",
        "paymentSuccess": "결제 성공",
        "invalidQrType": "잘못된 QR Code 유형",
        "tableMoved": "테이블 이동됨",
        "receiptVoided": "영수증이 무효화되었습니다"
    },
    "errorDescriptions": {
        "qrExpired": "사용하신 QR Code가 만료되었습니다.<br>직원에게 문의해 주세요.",
        "qrNotFound": "주문용 QR Code 정보를 찾을 수 없습니다.<br>직원에게 문의해 주세요.",
        "paymentSuccess": "이용해 주셔서 감사합니다!",
        "invalidQrType": "직원에게 연락하여 다이나믹 QR Code를 받으세요.",
        "tableMoved": "직원에게 연락하여 새 QR Code를 받으세요.",
        "receiptVoided": "이용해 주셔서 감사합니다.<br>도움이 필요하시면 직원에게 문의해 주세요."
    },
    waitForServe: '서빙 대기',
    DineInPaymentDetails: '결제',
    silomPayProDesp: 'Silom Pay Easy 안전 결제',
    billDetail: '전표 상세',
    minute: '분',
    paymentTImeExpired: '시간 만료',
    openApp: '앱 열기',
    callPayStaffSuccess: '직원을 호출했습니다<br>결제 완료를 위해 잠시 기다려 주세요',
    account: '계정',
    refNumber: '참조 번호',
    QRCodeBBL: '신용카드 QR Code',
    trackOrderStatus: '주문 상태 추적',
    all: '전체',
    noOrderThisStatus: '이 상태의 주문이 없습니다',
    orderCompleteThanks: '이용해 주셔서 감사합니다!',
    OnPreparingYourOrder: '주문 준비 중...',
    goToTracking: '추적 페이지로 이동',
    "dine-in": '매장 식사',
    typeOfOrder: '주문 유형',
    queue: '대기 번호',
    cooking: '조리 중',
    orderedAt: '주문 시간',
    orderTimeStatus: '주문 시간',
    acceptTimeStatus: '접수 시간',
    estTimeStatus: '예상 시간',
    newOrderDelivery: '신규 주문',
    acceptOrderDelivery: '주문 접수',
    readyToServeDelivery: '서빙 준비 완료',
    orderCompleted: '주문 종료',
    orderCanceled: '주문 취소',
    readyToShip: '배송 준비 완료',
    scanForPayment: '스캔하여 결제',
    orderType: '주문 유형',
    welcomeBack: "다시 오신 것을 환영합니다 👋",
    welcomeBackDespt: "로그인하여 주문을 계속하세요",
    orLoginWith: "또는 다음으로 로그인",
    dontHaveAccount: '계정이 없으신가요?',
    register: '회원가입',
    fullName: "전체 이름",
    fullNameDespt: '전체 이름',
    emailDespt: '이메일',
    createPassword: '비밀번호 생성',
    alreadyHaveAccount: '이미 계정이 있으신가요',
    verifyEmail: '이메일 인증',
    enterOTPSentTo: '로 전송된 OTP 입력',
    enterSixOTP: '6자리 OTP 입력',
    verifyOTP: 'OTP 인증',
    weWillSentOTPEmail: '이메일로 OTP를 보내드립니다',
    enterYourEmail: '이메일 입력',
    confirmNewPassword: '새 비밀번호 확인',
    sendOTP: 'OTP 전송',
    addPhoneNumber: '전화번호 추가',
    addPhoneForRegister: '가입용 전화번호 추가',
    enterPhone: '전화번호 입력',
    phoneUsed: '이미 사용 중인 전화번호입니다',
    emailUsed: '이미 사용 중인 이메일입니다',
    enterPassword: '비밀번호 입력',
    registerEmail: '등록된 이메일',
    otpInvalid6: "유효한 6자리 OTP를 입력해 주세요.",
    emailVerified: "이메일 인증 완료!",
    emailOrPasswordInvalid: '이메일 또는 비밀번호가 올바르지 않습니다',
    pleaseEnterEmail: '이메일을 입력해 주세요',
    otpSentToEmail: "이메일로 OTP를 전송했습니다",
    passwordNotMatch: "비밀번호가 일치하지 않습니다",
    resetPasswordCompleted: '비밀번호가 재설정되었습니다!',
    failResetPassword: '비밀번호 재설정 실패',
    completePhoneFail: '전화번호 등록 실패',
    plaseEnterValidEmail: '유효한 이메일 주소를 입력해 주세요',
    invalidPhoneNumber: '전화번호는 06, 08 또는 09로 시작하고 10자리여야 합니다',
    example: '예시',
    passwordSet: "6자 이상이며 숫자를 포함해야 합니다",
    SelectTableToAdd: '테이블',
    availableTable: '사용 가능',
    unAvailableTable: '사용 불가',
    SelectTableToAddDesp: '매장 식사용 테이블을 선택하세요<br>참고: 테이블 변경을 원하시면 직원에게 문의하세요',
    updatedStaus: '상태가 업데이트되었습니다',
    otpExpired: 'OTP 만료',
    and: "그리고",
    emailOTP: "이메일 OTP",
    emailOTPDesp: "이메일로 받은 OTP를 입력하세요",
    phoneOTP: "전화 OTP",
    phoneOTPDesp: "SMS로 받은 OTP를 입력하세요",
    checkSpamBox: '* 이메일을 받지 못하셨다면 스팸 또는 정크 폴더를 확인해 주세요. 도착까지 몇 분이 걸릴 수 있습니다.',
    DineInPaymentPending: '결제 대기 중',
    visitProceedPayment: '결제로 이동',
    proceedPayment: "결제 진행",
    proceedPaymentDesp: "이 전표는 현재 결제 처리 중입니다.<br>추가 주문을 하시려면,<br>진행 중인 결제를 먼저 취소해 주세요",
    queueIndex: '대기 번호',
    otpSentToPhone: 'SMS로 OTP를 전송했습니다.',
    failToSendOTP: 'OTP 전송 실패',
    somethingWentWrong: '문제가 발생했습니다',
    tableHasNoOrder: '테이블에 주문이 없습니다',
    kbankProceedPaymentDesp: '이 전표는 현재 결제 처리 중입니다.<br>추가 주문 또는 결제 방법 변경을 원하시면,<br>진행 중인 결제를 먼저 취소해 주세요'
,
  openHours: '영업',
}

export default messages
